import { Link } from 'react-router-dom';
import { liveHubs } from '../data/hubs.js';

/** Brand footer (BRAND.md section 10.4): brand column, two link columns, a
 *  connect column, the stacked vertical phrase, and a legal bar with the year. */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <img className="brand-badge" src="/brand/logo-160.webp" width="80" height="80" alt="Vet Tech Learning Hub badge" />
          <p>
            <strong>VetTech Learning Hub</strong> is a set of free certification study hubs for veterans,
            active-duty service members, and military spouses. Built for operators.
          </p>
        </div>

        <div className="footer-col">
          <h4>Study Hubs</h4>
          <ul>
            {liveHubs.map((h) => (
              <li key={h.id}><Link to={`/hub/${h.id}`}>{h.title}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4>Site</h4>
          <ul>
            <li><a href="/#mission">Mission</a></li>
            <li><a href="/#live">Live Hubs</a></li>
            <li><a href="/#pipeline">Pipeline</a></li>
            <li><a href="/#support">Support Us</a></li>
            <li><Link to="/ai-settings" className="ai-settings-link">AI Settings</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Connect</h4>
          <ul>
            <li><a href="mailto:info@vettechlearning.com">info@vettechlearning.com</a></li>
            <li><a href="/#newsletter">Newsletter</a></li>
            <li><a href="/#contact">Contact</a></li>
            <li><Link to="/signin">Sign In</Link></li>
          </ul>
        </div>

        <div className="footer-phrase" aria-hidden="true">
          <span>Training</span><span>Veterans</span><span>Building</span><span>Careers</span>
        </div>
      </div>

      <div className="footer-legal">
        <div className="footer-legal-inner">
          <span>&copy; {year} <strong>VetTech Learning Hub</strong> &middot; Built for operators</span>
          <span>Design <strong>WebDesign by ZonesHosting</strong> &middot; &copy; {year}</span>
        </div>
      </div>
    </footer>
  );
}